import React from 'react';
import { useFormik } from 'formik';
import { Link, useHistory } from 'react-router-dom';
import '../../dist/assets/stylesheets/css/signup.css';
import { SignUp } from '../util/signupAPI';
import { formatAuthFailureMessage } from '../util/authErrors';
import { useDispatch } from 'react-redux';
import { notificationActions } from '../store/notification-slice';
import logo from './logo.PNG';

function SignUpPage() {
    const formik = useFormik({
        initialValues: {
            first: '',
            last: '',
            email: '',
            password: '',
            license_key: '',
        },
    });

    const { values, setFieldValue } = formik;
    const history = useHistory();
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await SignUp({ ...values });
            const data = await res.json();

            if (res.ok && data.status === 'success') {
                dispatch(
                    notificationActions.setNotification({
                        show: true,
                        status: 'success',
                        message: 'Signup successful!',
                    })
                );
                history.push('/login');
            } else {
                dispatch(
                    notificationActions.setNotification({
                        show: true,
                        status: 'error',
                        message: formatAuthFailureMessage(data, res.status),
                    })
                );
            }
        } catch (err) {
            console.error(err);
            dispatch(
                notificationActions.setNotification({
                    show: true,
                    status: 'error',
                    message: err.message || 'An unexpected error occurred!',
                })
            );
        }
    };

    return (
        <div id="signup-page" className="auth-split-page">
            <section id="signup-container">
                <div className="signup-logo-wrap">
                    <img src={logo} alt="EvoVision" className="signup-logo" />
                </div>
                <header className="signup-header">Sign Up</header>
                <form onSubmit={handleSubmit} id="signup-form">
                    <label htmlFor="signup-first">First name</label>
                    <input
                        id="signup-first"
                        name="first"
                        autoComplete="given-name"
                        placeholder="First name"
                        value={values.first}
                        onChange={(e) => setFieldValue('first', e.target.value)}
                        className="signup-input"
                    />
                    <label htmlFor="signup-last">Last name</label>
                    <input
                        id="signup-last"
                        name="last"
                        autoComplete="family-name"
                        placeholder="Last name"
                        value={values.last}
                        onChange={(e) => setFieldValue('last', e.target.value)}
                        className="signup-input"
                    />
                    <label htmlFor="signup-email">Email</label>
                    <input
                        id="signup-email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        placeholder="you@example.com"
                        value={values.email}
                        onChange={(e) => setFieldValue('email', e.target.value)}
                        className="signup-input"
                    />
                    <label htmlFor="signup-password">Password</label>
                    <input
                        id="signup-password"
                        name="password"
                        type="password"
                        autoComplete="new-password"
                        placeholder="Create a password"
                        value={values.password}
                        onChange={(e) => setFieldValue('password', e.target.value)}
                        className="signup-input"
                    />
                    <label htmlFor="signup-license">License key</label>
                    <input
                        id="signup-license"
                        name="license_key"
                        autoComplete="off"
                        placeholder="License key"
                        value={values.license_key}
                        onChange={(e) => setFieldValue('license_key', e.target.value)}
                        className="signup-input"
                    />
                    <div id="signup-button-container">
                        <button className="blue-button signup-submit" type="submit">
                            Sign Up
                        </button>
                    </div>
                </form>
                <p className="signup-footer">
                    Already have an account?{' '}
                    <Link to="/login" className="signup-login-link">
                        Log in
                    </Link>
                </p>
            </section>
            <section id="signup-hero" aria-hidden="true" />
        </div>
    );
}

export default SignUpPage;
